import { primitives, semantic, componentTokens } from '../tokens';

const legacyColors = {
  primary: primitives.color.brand[500],
  secondary: primitives.color.brand[700],
  accent: primitives.color.brand[900],
  background: primitives.color.pageBg,
  text: primitives.color.textLegacy,
  white: primitives.color.neutral[0],
  gray: primitives.color.textMutedLegacy,
  success: primitives.color.green[500],
  error: primitives.color.red[500],
  warning: primitives.color.amber[500],
} as const;

const theme = {
  colors: legacyColors,
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    xxl: '3rem',
  },
  breakpoints: {
    xs: primitives.breakpoint.xs,
    sm: primitives.breakpoint.sm,
    md: primitives.breakpoint.md,
    lg: primitives.breakpoint.lg,
    xl: primitives.breakpoint.xl,
    '2xl': primitives.breakpoint['2xl'],
  },
  typography: {
    fontFamily: "'Work Sans', sans-serif",
    fontSize: {
      small: '0.875rem',
      base: '1rem',
      large: '1.125rem',
      h1: '2.5rem',
      h2: '2rem',
      h3: '1.75rem',
      h4: '1.5rem',
      h5: '1.25rem',
      h6: '1rem',
    },
    fontWeight: {
      light: 300,
      regular: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },
  },
  primitives,
  semantic,
  componentTokens,
};

export default theme;
